<!-- this is the component for each image reference-->
<div class="grey lighten-3 py-2 px-2" style="border-radius: 10px;">
    <div class="row">
        <div class="col-md-12">
            <div class="btn-group" mdbDropdown *ngIf="actions">
                <mdb-badge mdbDropdownToggle classInside="dropdown-toggle" class="waves-effect rtr-badge-green-light"
                    mdbWavesEffect>Actions</mdb-badge>
                <div class="dropdown-menu dropdown-ins">
                    <a class="dropdown-item" (click)="actions.delete(vm.data.code)">Delete</a>
                    <!-- <a class="dropdown-item" (click)="actions.makePrimary(vm.data.code)">Make Primary</a> -->
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12 col-md-6">
            <div class="view overlay" style="border-radius: 5px; height: 180px;">
                <!-- <mdb-badge *ngIf="vm.isPrimary" success="true"
                    style="position: absolute; left:10px; top:10px; z-index: 20;">
                    Primary</mdb-badge> -->
                    
                <app-form-file-image [imageData]="vm.data.fileUrl" [alt]="vm.data.name"></app-form-file-image>                    
                <!-- <img [src]="imageSrc" class="img-fluid" [alt]="vm.data.name"> -->
                <!-- <div class="mask flex-center waves-effect waves-light">
                    <p class="white-text">Show</p>
                </div> -->
            </div>
        </div>
        <div class="col-sm-12 col-md-6">
            <app-form-input [vm]="vm.description"></app-form-input>
        </div>
    </div>
</div>